export default __webpack_public_path__ + "static/media/DevLogin.78d38ff0.png";